import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Flight, Segment } from 'src/app/core/models/itinerary.model';
import { InvoluntaryChangeService } from 'src/app/involuntary-change/services/involuntary-change.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { AirportIconsService } from 'src/app/search-result/services/airport-icons.service';
import { Subscription } from 'rxjs';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';

const pendingCancel = 'pendingCancel';
const changed = 'Changed';

@Component({
  selector: 'app-segment-info',
  templateUrl: './segment-info.component.html',
  styleUrls: ['./segment-info.component.scss']
})
export class SegmentInfoComponent implements OnInit, OnDestroy {
  @Input() mode: string;
  @Input() hasFare = false;
  @Input() segment: Segment;
  @Input() index: number;
  @Input() canSelect: boolean;
  @Input() isInvoluntary = false;
  @Input() isMultidestiny = true;
  @Input() baggageAllowance: number;
  @Input() isExchangeFlight = false;
  @Input() isHeader: boolean;
  @Input() showSeatsAvailability = false;

  @Output() selected = new EventEmitter<{ indexs: number[]; type?: string }>();
  @Output() changeClass = new EventEmitter<string>();
  @Output() openSyncForm = new EventEmitter<Segment>();
  @Output() loadAlternatives = new EventEmitter<Segment>();

  subscriptions = new Subscription();

  isAirline$: boolean;
  showModalOriginalFlight = false;
  showButtonConfirmrescheduled = true;
  hasSelectedPassengers = false;
  flights: number[];
  recommendationFlightsForChange: Flight[];
  rescheduledOriginalFlights: Flight[] = [];
  rescheduledRecommendationFlights: Flight[] = [];

  constructor(
    private airportIcons: AirportIconsService,
    private icService: InvoluntaryChangeService,
    private settingsService: SettingsService,
    private itineraryService: ItineraryService
  ) {}

  ngOnInit() {
    this.callComponentSubscriptions();
    this.segment = this.airportIcons.setIcons(this.segment);
    this.recommendationFlightsForChange = this.segment.flights;
    this.recommendationFlightsForChange.forEach((x) => {
      if (x.status === pendingCancel) {
        x.status = changed;
      }
    });
    this.segment.recommendationFlights.forEach((x) => {
      if (x.haveSegmentNotSc && this.showButtonConfirmrescheduled) {
        this.showButtonConfirmrescheduled = false;
      }
    });
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      this.settingsService.getClientIsAirline().subscribe((isAirline) => {
        this.isAirline$ = isAirline;

        if (isAirline) {
          this.segment.originalFlights.forEach((flight) => {
            if (flight && flight.status === pendingCancel) {
              this.rescheduledOriginalFlights.push(flight);
            }
          });
        } else {
          this.rescheduledOriginalFlights = this.segment.originalFlights;
        }

        this.rescheduledRecommendationFlights = this.segment.recommendationFlights;
      })
    );

    this.subscriptions.add(
      this.itineraryService.getSelectedPassengersQuote().subscribe((passengers) => {
        if (passengers?.length > 0) {
          this.hasSelectedPassengers = true;
        } else {
          this.hasSelectedPassengers = false;
        }
      })
    );
  }

  expand(event: Event) {
    event.preventDefault();
    this.segment.isOpen = !this.segment.isOpen;
  }

  over() {
    if (this.canSelect && this.segment.canSelect) {
      this.segment.isHovered = true;
    }
  }

  leave() {
    this.segment.isHovered = false;
  }

  click() {
    if (this.canSelect && this.segment.canSelect) {
      this.segment.isChecked = !this.segment.isChecked;
      this.segment.isChecked ? this.check() : this.uncheck();
    }
  }

  check() {
    this.selected.emit({ indexs: this.getIndexs(), type: 'all' });
  }

  uncheck() {
    this.selected.emit({ indexs: [], type: 'none' });
  }

  some() {
    this.selected.emit({ indexs: this.flights, type: 'some' });
  }

  typeSelect(selectAll: string) {
    if (selectAll === 'all') {
      this.click();
    } else {
      this.some();
    }
  }

  selectFlight(selectedFlights: number[]) {
    this.flights = selectedFlights;
  }

  getIndexs() {
    return this.segment.flights.map((flight) => flight.index);
  }

  loadSegmentAlternatives() {
    this.icService.loadAlternativesTrigger.next(null);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
